import { useDispatch } from 'react-redux';

import ListMenu from "../Commons/ListMenu";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';


import "./AdminProductMenu.css";

const AdminPage = (props) =>
{
  //Redux
  const Dispatch = useDispatch();

  useMount(() =>
  {
    Dispatch(setCurrentNavigation("Ad_Product"));
  }, []);

  return (
    <div>
      <div className="adminproductmenu_text">
        Product
      </div>
      <div className="adminproductmenu_menu_cont">
        <ListMenu />
      </div>
    </div>
  )

};

export default AdminPage;